import Page1 from "./Page1"

let content = [Page1]

export default content
